import { GetCGPercentContextQuery } from "@/graphql/graphql";
import { Circle, Event } from "@/models";
import { create } from "zustand";

export interface IcircleEventStore {
  allCircles?: Circle[];
  myCircles?: Circle[];
  allEvents?: Event[];
  myEvents?: Event[];
  archivedEvents?: Event[];  
  isOpenCreateCircleModal?: boolean;
  isOpenCreateEventModal?: boolean;
  allEventsCGP?: GetCGPercentContextQuery[];
  allCirclesCGP?: GetCGPercentContextQuery[];
}

interface mutateState {
  setState: (payload: IcircleEventStore) => void;
}

const useCircleEventStore = create<IcircleEventStore & mutateState>((set) => ({
  allCircles: [],
  myCircles: [],
  allEvents: [],
  myEvents: [],
  archivedEvents: [],
  setState: (payload) =>
    set((state) => ({
      ...state,
      ...payload, // Only merge the properties in payload
    })),
}));

export default useCircleEventStore;
